<template>
  <form class="form-horizontal">
    <div v-if="id" class="form-group row">
      <label class="col-md-3 col-form-label">Id </label>
      <div class="col-md-9">
        <input type="text" id="id-input" name="id" class="form-control"
               placeholder="id" :value="id" disabled>
      </div>
    </div>
    <div v-if="!editable" class="form-group row">
      <label class="col-md-3 col-form-label">Last seen</label>
      <div class="col-md-9">
        <input type="text" id="last_seen-input" name="last_seen"
               class="form-control" placeholder="Last seen"
               :value="localFormData.last_seen" disabled>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-md-3 col-form-label" for="email-input">Email</label>
      <div class="col-md-9">
        <input type="email" id="email-input" name="email" class="form-control"
               placeholder="Enter Email" v-model="localFormData.email" :disabled="!editable">
      </div>
    </div>
    <div class="form-group row">
      <label class="col-md-3 col-form-label" for="firstname-input">First name</label>
      <div class="col-md-9">
        <input type="text" id="firstname-input" name="firstname" class="form-control"
               placeholder="Enter first name" v-model="localFormData.firstname"
               :disabled="!editable">
      </div>
    </div>
    <div class="form-group row">
      <label class="col-md-3 col-form-label" for="lastname-input">Last name</label>
      <div class="col-md-9">
        <input type="text" id="lastname-input" name="lastname" class="form-control"
               placeholder="Enter last name" v-model="localFormData.lastname"
               :disabled="!editable">
      </div>
    </div>
    <div class="form-group row" v-if="this.$route.params.id">
      <label class="col-md-3 col-form-label" for="status-select">Status</label>
      <div class="col-md-9">
        <select id="status-select" name="status" class="form-control" v-model="localFormData.status"
                :disabled="!editable">
          <option value="enabled">
            Enabled
          </option>
          <option value="disabled">
            Disabled
          </option>
        </select>
      </div>
    </div>
    <div class="form-group row"
         v-if="this.$route.params.id">
      <label class="col-md-3 col-form-label">Deleted</label>
      <div class="col-md-9 col-form-label">
        <div class="form-check">
          <input class="form-check-input" type="radio" :value="true" id="deleted-true"
                 name="deleted" v-model="localFormData.deleted" :disabled="!editable">
          <label class="form-check-label" for="radio1">
            True
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" :value="false"
                 id="deleted-false"
                 :disabled="!editable"
                 name="deleted" v-model="localFormData.deleted">
          <label class="form-check-label" for="radio2">
            False
          </label>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-md-3 col-form-label" for="role-select">Role</label>
      <div class="col-md-9">
        <select id="role-select" name="role" class="form-control" v-model="localFormData.role_id"
                :disabled="!editable" style="text-transform: capitalize;">
          <option v-for="role in roles" :value="role.id" :key="role.slug">
            {{ role.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="form-group row" v-if="fields[0] && localFormData.role_id === 3">
      <label class="col-md-3 col-form-label" for="role-select">Clients</label>
      <div class="col-md-9">
        <el-select
            v-model="localFormData.clients"
            size="small"
            class="w-100"
            :disabled="!editable"
            placeholder="Select clients" filterable multiple collapse-tags
        >
          <el-option-group label="Press Tab/Escape to exit">
            <el-option
                v-for="value in getClients(fields[0].data)"
                :key="value.value" :label="value.value" :value="value.value">
              <span style="float: left">{{value.value}}</span>
            </el-option>
          </el-option-group>
        </el-select>
      </div>
    </div>
    <div v-if="editable" class="form-group row">
      <label class="col-md-3 col-form-label" for="password-input">Password</label>
      <div class="col-md-9">
        <input type="password" id="password-input" name="password" class="form-control" v-model="localFormData.password"
               placeholder="Enter password">
      </div>
    </div>
  </form>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import userGetters from '../../store/modules/users/getterTypes'
import studiesGetters from '../../store/modules/studies/getterTypes'
import studiesActions from '../../store/modules/studies/actionTypes'

export default {
  name: 'EditUser',
  emits: ['update:formData'],
  props: {
    editable: Boolean,
    formData: Object,
    id: {
      type: Number,
      required: false
    }
  },
  data () {
    return {
      localFormData: { ...this.formData }
    }
  },
  computed: {
    ...mapGetters({
      fields: studiesGetters.GET_FIELDS,
      roles: userGetters.GET_ROLES
    })
  },
  methods: {
    ...mapActions({
      getFields: studiesActions.FETCH_FIELDS
    }),
    getClients (data) {
      return data.find(el => el.field === 'client').options
    }
  },
  async beforeMount () {
    if (!this.fields.length) {
      await this.getFields()
    }
  },
  watch: {
    // Compare by value: both branches assign a freshly spread object, so an
    // identity check can never be false and the pair never settles - each pass
    // allocates more objects and re-triggers the other watcher.
    formData: {
      deep: true,
      handler (value) {
        if (!_.isEqual(value, this.localFormData)) {
          this.localFormData = _.cloneDeep(value)
        }
      }
    },
    localFormData: {
      deep: true,
      handler (value) {
        if (!_.isEqual(value, this.formData)) {
          this.$emit('update:formData', _.cloneDeep(value))
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
